<template>
    <div class="">
        <div class="bgbg"></div>
        <div class="box">
            <el-row>
                <el-col :span="24">
                    <img class="logo" src="../../../public/images/logo.png" alt="" />
                </el-col>
            </el-row>
            <el-row class="shu">
                <input type="password" v-model="password" class="password" placeholder="请输入密码" />
                <img src="../../../public/images/icon-suo.png" alt="" />
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-button type="primary" round class="login-button" @click="login">登录</el-button>
                </el-col>
            </el-row>

        </div>
    </div>
</template>
<script>
    export default {
        name: "login",
        data() {
            return {
                password: '',
            };
        },
        created() {},
        mounted() {},

        methods: {
            login(){
                if(this.password == ''){
                    this.$message({
                        type: 'error',
                        message: '请输入密码'
                    })
                    return false;
                }
                const loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.post('/login', {password: this.password}).then(res => {
                    loading.close();
                    if (res.data.code == 0) {
                        localStorage.setItem('access_token', res.data.data.access_token);
                        this.$router.push('/')
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                });
            },
        },
    };
</script>
<style lang='less' scoped>
    .bgbg {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, #3F72FF 0%, #8FD8FF 100%);
    }

    .box {
        position: fixed;
        left: 50%;
        top: 50%;
        z-index: 2;
        width: 480px;
        height: 346px;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.16);
        border-radius: 16px 16px 16px 16px;
        transform: translate(-50%, -50%);
        padding: 0 32px 32px;
        box-sizing: border-box;
    }

    .box .logo {
        display: block;
        width: 280px;
        margin: 32px auto 54px auto;
    }
    .shu{
        position: relative;
    }
    .shu img{
        position: absolute;
        right: 16px;
        top: 10px;
        width: 36px;
    }
    .password{
        display: block;
        width: 100%;
        height: 56px;
        line-height: 56px;
        border: 0;
        background: #FFFFFF;
        border-radius: 56px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #333;
        border: 1px solid #E5E5E7;
        box-sizing: border-box;
        margin-bottom: 32px;
        padding: 12px 16px;
    }
    .login-button {
        width: 100%;
        height: 56px;
        line-height: 56px;
        text-align: center;
        padding: 0;
        border: 0;
        background: linear-gradient(180deg, #67BDF9 0%, #4F6DEE 100%);
        border-radius: 56px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #FFFFFF;
    }
</style>
